import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'

import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'
import HeaderPagination from '../Custom/HeaderPagination'
import routes from '../../Routes'
import useTenantsPagination from './hooks/useTenantsPagination'

const visibleButtons = {
    create: false,
    composite: false,
    import: false,
    export: false,
    deleted: false,
    search: true,
}

function BackofficeTenantsEliminados({ history }) {
    const {
        tenants,
        page,
        totalRegister,
        totalPage,
        handleBuscador,
        nextPage,
        previousPage,
    } = useTenantsPagination(history, false)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faBuilding}
                        title={'Tenants eliminados'}
                    />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.TENANTS_BACKOFFICE}
                    visibleButtons={visibleButtons}
                    handleBuscador={handleBuscador}
                />

                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Nombre</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tenants.map((t) => (
                            <tr key={t.id}>
                                <td>{t.id}</td>
                                <td>{t.nombre}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(BackofficeTenantsEliminados)
